module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-3.f05a78c0.webp";